import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

export interface CostCenterOption {
  id: number;
  code: string;
  name: string;
  primary?: boolean;
  delegated?: boolean;
}

type Props = {
  value?: number | null;
  options: CostCenterOption[];
  disabled?: boolean;
  onChange: (costcenterid: number) => Promise<void> | void;
};

export default class ActivityPlanningCostCenterSelector extends React.PureComponent<Props> {
  render() {
    const selected = this.props.options.find((x) => x.id === Number(this.props.value || 0)) || null;
    if (this.props.options.length <= 1) return null;

    return (
      <Autocomplete
        size="small"
        sx={{ minWidth: 320 }}
        options={this.props.options}
        value={selected}
        disabled={this.props.disabled}
        getOptionLabel={(x) => `${x.code} — ${x.name}`}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        onChange={(_, x) => x && void this.props.onChange(x.id)}
        renderInput={(params) => <TextField {...params} label="Working Cost Center" />}
      />
    );
  }
}
